/* ADD DOUBLE CLICK */
function addDoubleClickNav(selector) {
    var isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
    };
    if (isMobile.any()) {
        // Click Eventad
        $(selector + '>li').has('ul').on('touchstart', function (e) {
            if ($(this).hasClass('hover')) {
                return true;
            } else {
                $(this).addClass('hover');
                $(this).siblings().removeClass('hover');
                e.preventDefault();
                return false; //extra, and to make sure the function has consistent return points
            }
        });

        // Wieder entfernen, wenn man woanders hin klickt
        $(document).on('touchstart', function (e) {
            if ($(e.target).is(selector + '>li.hover *') === false) {
                $(selector + '>li.hover').removeClass('hover');
            }
        });
    }

}